// import React,{ useState } from 'react'
// import styled from '@emotion/styled';

// const StyledViewmore = styled.div`
//   a{
//     color: #2D53DA !important;
//     font-size:12px;
//     font-weight:bold;
//     white-space:nowrap;
//   }
// `;

// function ViewMore ({
//   value,
//   count = 50
// }) {
//   const [isExpanded, setIsExpanded] = useState(false);

//   return(
//     <>
//         {value == null || value == "" ? "-" : (<>
//           {value.length  > count ? (
//                     <>
//                     {isExpanded ? (
//                         <StyledViewmore>{value} <a onClick={() => setIsExpanded(false)} >View less</a></StyledViewmore>
//                     ) : (
//                         <StyledViewmore>
//                         {value.substring(0, count)}... <a onClick={() => setIsExpanded(true)} >View more</a>
//                         </StyledViewmore>
//                     )}
//                     </>
//                 ):<>{value}</>}
//         </>)}
//     </>
//   )
// }

// export default ViewMore

import React, { useState } from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

const StyledViewmore = styled.div`
  a {
    color: #2d53da !important;
    font-size: 12px;
    font-weight: bold;
    white-space: nowrap;
  }
`;

function ViewMore({ value, count = 50 }) {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      {value == null || value == "" ? (
        "-"
      ) : (
        <>
          {value.length > count ? (
            <>
              {isExpanded ? (
                <StyledViewmore>
                  {value}{" "}
                  <a onClick={() => setIsExpanded(false)}>{t("View less")}</a>
                </StyledViewmore>
              ) : (
                <StyledViewmore>
                  {value.substring(0, count)}...{" "}
                  <a onClick={() => setIsExpanded(true)}>{t("View more")}</a>
                </StyledViewmore>
              )}
            </>
          ) : (
            <>{value}</>
          )}
        </>
      )}
    </>
  );
}

export default ViewMore;
